import { ChangeEvent } from 'react'
import { useField } from 'react-final-form'
import { Box, FormControlLabel, Radio, RadioGroup, Typography } from '@material-ui/core'

import type { ChecklistAnswerComment } from '../../../services/web/useChecklist'

export interface ChecklistAnswerRadioGroupProps {
    name: string
    answers: ChecklistAnswerComment[]
    disabled?: boolean
}
function ChecklistAnswerRadioGroup(props: ChecklistAnswerRadioGroupProps) {
    const { name, answers, disabled } = props
    const { input } = useField<ChecklistAnswerComment[]>(name)

    const selectedId = answers.find((e) => e.checked)?.checklistID ?? undefined

    function onChange(e: ChangeEvent<HTMLInputElement>) {
        const selectedId = Number(e.target.value)
        const updatedAnswers = answers.map((e) => ({
            ...e,
            checked: e.checklistID === selectedId,
        }))
        input.onChange(updatedAnswers)
    }

    return (
        <Box pl={2}>
            <RadioGroup row name={name} value={selectedId} onChange={onChange}>
                {answers.map((answer) => (
                    <FormControlLabel
                        key={answer.checklistID}
                        label={<Typography variant="body2">{answer.nameTH}</Typography>}
                        value={answer.checklistID}
                        disabled={disabled}
                        control={<Radio color="primary" />}
                    />
                ))}
            </RadioGroup>
        </Box>
    )
}

export default ChecklistAnswerRadioGroup
